import { type ReactNode } from "react";
import { Spinner } from "react-bootstrap";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <Spinner animation="border" role="status" />
      </div>
    );
  }
  if (auth.status === "unauthenticated") {
    sessionStorage.setItem("naas_post_login_redirect", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
